import React from "react";
import { genURL, gengetURLTEST, genpostURL, genpostURLTEST, genURLTEST } from './../_getjson';
import { BootstrapTable, TableHeaderColumn, DeleteButton } from 'react-bootstrap-table';
import { parseJwt } from "../parseJWT";
import PopupApcode from './../PopUp/PopUpApcode';
import PopUpOther from './../PopUp/PopUpOther';
import PopUpSearchPspayment/* , { ReDate } */ from '../PopUp/PopUpSearchPspayment';
import PopUpSaveMoney from "./../PopUp/PopUpSaveMoneyExp"
import PopUpReport from "../PopUp/_fromShow";
import Chackdocno from './../CustomFunction/Docno/GetDocno'
import checkincome from './../CustomFunction/Checkcsincom/Checkname'
import Checkcsexpenses from './../CustomFunction/Checkcsexpenses/Checkname'
import ChackAp from './../CustomFunction/Csap/GetAp'
import CheckBrabchname from './../CustomFunction/Branch/Checkname'
import CheckDepartmentname from './../CustomFunction/Department/Checkname'
import CheckUser from '../CustomFunction/Csuser/GetUser'
import axios from 'axios'
import Moment from 'moment';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Grid, Col } from "react-bootstrap";
import FullScreenDialog1 from '../PopUp/FullScreendialogs/FullScreen'
import MaterialUIPickers from "../Components/CustomDatepicker/MaterialUIPickers"
import { checkData } from '../_source/checkDatainput'
import Topbar from "../Components/Customtopbar/Topbar";
import APInvdebt from './../PopUp/FullScreendialogs/Components/APInvdebt';
import APInvdebtpaybill from './../PopUp/FullScreendialogs/Components/APInvdebt';
import Csprepayment from './../PopUp/FullScreendialogs/Components/Csprepayment';
import Inputtax from './../PopUp/FullScreendialogs/Components/Inputtax';
import Playmentwithholding from '../PopUp/Playmentwithholding/Playmentwithholding';
import Csapdeposit from './../PopUp/FullScreendialogs/Components/Csapdeposit';
import SelectDatas from "./../PopUp/SelectData"
import PopUpSaveMoneyExp from './../PopUp/PopUpSaveMoneyExp';
import Rechecked from './Components/Rechecked'
import { Await } from "react-router-dom";


const ReDate = (Date) => {
    let dataRe = ""
    if (Date) {
        dataRe = Moment(Date, 'YYYY-MM-DD').add(543, "year").format('DD/MM/YYYY')
    }
    return dataRe
};
export default class Index extends React.Component {

    customStyle = () => {
        return {
            backgroundColor: '#f2f2f2'
        };
    }
    state = { tableData: [] }
    constructor(props) {
        super(props);
        this.APCode = React.createRef();
        this.APName = React.createRef();
        this.Groupdata_code = React.createRef();
        this.Groupdata = React.createRef();
        this.DeliNumber = React.createRef();
        this.Currencycode = React.createRef();
        this.exchangerate = React.createRef("1.0000000");
        this.Department_code = React.createRef();
        this.Department = React.createRef();
        this.Branch_code = React.createRef();
        this.Branch = React.createRef();
        this.Sumpayamount = React.createRef();
        this.bathpayamount1 = React.createRef();
        this.bathpayamount2 = React.createRef();
        this.Discamount = React.createRef();
        this.bathprofit = React.createRef();
        this.bathloss = React.createRef();
        this.SALECODE_CODE = React.createRef();
        this.SALECODE = React.createRef();
        this.Depositpayment = React.createRef();
        this.Remark = React.createRef();
        this.Netpayamount = React.createRef();
        this.state = {
            SwitchPopupArcode: false,
            tableData: [],
            selectRow: [],
            DocType: [],
            SGstatus: true,
            DisInput: true,
            mstremark: '-',
            tfdocPrint: "",
            CHLOOP: 0,
            loading: "none",
            Currencycode: "บาท",
            Expcode: "",
            rowtb: "300",
            Branch_txt: "",
            Department_txt: "",
            Department_code: "",
            Groupdata_txt: "",
            CSdelete: "far fa-trash-alt",
            CSdeletes: false,
            CSdelete_yes: false,
            AmountPayable: 0,
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            show1: false,
            ddd: "",
            Namedelete: "",
            dataMultipletax: "",
            Docdate1: "",
            Groupcode: "",
            Groupname: "",
            Docno: "",
            Remark: "",
            Docdate: "",
            inputtax: [],
            Refundablerate: '',
            Refundablevalue: '',
            Taxrefund: '',
            Totaltax: 0,
            //เลือกใบเตรียมจ่าย
            // chkCsprepayment: false,
            // บันทึกภาษีหัก ณ ที่จ่าย 
            Docgroupcode0: 'WT001',
            Totaltax0: 0,
            Wtaxamount: 0,
            // ชำระค่าบริการ
            Totaltax1: 0,
            Vat: 0,
            Payfirservice: [],
            //ภาษีหัก ณ ที่จ่าย 
            Withholding: [],

            //หักเงินมัดจำ
            tbCsapdeposit: "",
            sumsapdeposit: 0,
            //savemonney
            Cashbalance: 0,
            CashReceipt2: 0,
            Pettycash: 0,
            Bankamount: 0,
            Creditsum: 0,
            Incomesum: 0,
            Bankexpend: 0,
            Expensessum: 0,
            checkenableInput: [],
            PROJECT: "",
            recheckdata: [],
        }
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date = myDate.getDate();
            if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1);
            if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    ResetThisPage = (type) => {
        if (type === "NEW") {
            if (this.state.iconNoWash) {
                this.onAddValue("Groupdata", "PR");
            } else {
                this.componentDidMount();
            }
        } else if (type === "SAVE") {
            window.location.replace("/PSPAYMENT");
        }
    }
    async componentDidMount() {
        //เช็คเปิดปิด text 
        await this.setState({
            checkenableInput: JSON.parse(localStorage.getItem('checkoftxt'))
        })

        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        // this.Get_UserCode(localStorage.getItem("Username"));
        this.onAddValue("Csuser", SITECODESTR.User.CODE);
        this.SALECODE.current.value = localStorage.getItem("UsernameTH");
        this.onAddValue("Branch", SITECODESTR.User.SITECODE);
        this.exchangerate.current.value = "1.0000000"
        var d = new Date();
        console.log(Moment().startOf("month").add(543, "year").format('DD/MM/YYYY'));
        console.log(Moment().startOf("month").format('YYYY-MM-DD'));
        console.log(Moment('04/11/2564', 'DD/MM/YYYY').add(-543, "year").format('YYYY-MM-DD'));
        // var dd = Moment.locale('th')
        // this.date = Moment('04/11/2564').add(-543, 'year').format('YYYY-MM-DD')
        // (Moment(this.state.inputtax[i].Invoicedate).format('YYYY-MM-DD')) 
        // console.log(dd,this.date);
    }

    Get_Arcode = (event) => {
        if (this.APCode.current.value === "") {
            this.APName.current.value = "";
        }
        if (event.key === "Enter" && event.target.value !== "") {
            this.setState({ openBackdrop: true })
            var arcode = (event.target.value).trim();
            var url = "CSAR/ARCode?arcode=" + arcode + "&user=" + localStorage.getItem("Username");
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 3600 }).then(res => {
                if (res.data.length > 0) {
                    this.APCode.current.value = res.data[0].CODE;
                    this.APName.current.value = res.data[0].NAMETH;
                    this.setState({ openBackdrop: false })
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล" })
                    this.APCode.current.value = "";
                    this.APName.current.value = "";
                    this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                console.log(error);
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                this.setState({ openBackdrop: false })
            });
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
    }
    _calprice = () => {
        var Sumpayamount = 0.00;
        var _sumamountC5 = 0.00;
        for (var i = 0; i < this.state.tableData.length; i++) {
            if (this.state.tableData[i].T_Payment) {
                Sumpayamount += parseFloat(this.state.tableData[i].T_Payment)
            }
            if (this.state.tableData[i].T_Residual) {
                _sumamountC5 += parseFloat(this.state.tableData[i].T_Residual)
            }
        }
        setTimeout(() => {
            this.setState({ _sumamountC5_s: _sumamountC5 })
        }, 30);
        this.bathpayamount1.current.value = Sumpayamount.toFixed(2);
        this.bathpayamount2.current.value = parseFloat(Sumpayamount - this.state.sumsapdeposit).toFixed(2);
        this.Sumpayamount.current.value = Sumpayamount.toFixed(2);
        this.Netpayamount.current.value = parseFloat((Sumpayamount - this.Depositpayment.current.value) - this.Discamount.current.value).toFixed(2);
        var Discamount = 0;
        if (this.Discamount.current.value) { Discamount = parseFloat(this.Discamount.current.value).toFixed(2); }
        this.Discamount.current.value = parseFloat(Discamount).toFixed(2);
        this.Depositpayment.current.value = parseFloat(this.state.sumsapdeposit).toFixed(2);
        this.bathprofit.current.value = parseFloat(this.state.sumsapdeposit).toFixed(2);
        this.setState({ AmountPayable: this.Netpayamount.current.value });
    }
    Cal_Price1 = (e) => {
        if (e.key === "Enter" && e.target.value !== "") {
            this._calprice();
        }
    }
    Get_UserCode = (data) => {
        this.setState({ UserCode_code: localStorage.getItem("Username") });
        this.setState({ UserCode_txt: localStorage.getItem('UsernameTH') });
        this.setState({ UserCode: localStorage.getItem('UsernameTH') });
    }
    SelectSetData = (type, data) => {
        switch (type) {
            case "Docdate":
                this.setState({ Docdate: data })
                break;
            case "PROJECT":
                this.setState({ PROJECT: data })
                break;
            default: break;
        }
    }
    onKeyPress = (e) => {
        var value = e.target.value;
        if (e.key === 'Enter') {
            if (e.target.name === 'Groupdata') {
                this.setState({ openBackdrop: true })
                var url = "CSDOCGROUP/Code?tablename=CSPAYMENT&code=" + e.target.value;
                console.log(genURL("CSDOCGROUP", url));
                axios.get(genURL(url), { timeout: 3600 }).then(res => {
                    if (res.data.length > 0) {
                        this.setState({ Groupdata_txt: res.data[0].MYNAMETH });
                        this.setState({ DOCGROUP_code: res.data[0].CODE });
                        this.Groupdata.current.value = res.data[0].MYNAMETH;
                        this.setState({ RUNGROUP_code: res.data[0].RUNGROUP });
                        this.onClickDocNo(res.data[0].CODE)
                        this.setState({ openBackdrop: false })
                    } else {
                        this.setState({ opensnackbar: true })
                        this.setState({ color: "warning" })
                        this.setState({ icon: ErrorIcon })
                        this.setState({ messagealert: "ไม่พบข้อมูล" })
                        this.setState({ Groupdata_txt: "" });
                        this.setState({ DOCGROUP_code: "" });
                        this.Groupdata.current.value = "";
                        this.DeliNumber.current.value = "";
                        this.setState({ openBackdrop: false })
                    }
                }).catch(error => {
                    console.log(error);
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
                    this.setState({ openBackdrop: false })
                });
            }
            if (e.target.name === 'Department') {
                this._getdepartment(e.target.value)
            }
            if (e.target.name === 'Branch') {
                this._getSite(value)
            }
        }
    }
    _getdepartment = async (code) => {
        this.setState({ openBackdrop: true })
        var url = "CSDEPARTMENT/ByCode?code=" + code + "&user=" + localStorage.getItem("Username");
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data.length > 0) {
                this.setState({ Department_txt: res.data[0].MYNAMETH });
                this.setState({ Department_code: res.data[0].CODE });
                this.Department.current.value = res.data[0].MYNAMETH;
                this.setState({ openBackdrop: false })
            } else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่พบข้อมูล" })
                this.setState({ Department_txt: "" });
                this.setState({ Department_code: "" });
                this.Department.current.value = "";
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
            this.setState({ openBackdrop: false })
        });
    }
    _getSite = async (code) => {
        this.setState({ openBackdrop: true })
        var url = "CSSITE/Getsite?Code=" + code + "&user=" + localStorage.getItem("Username");
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 3600 }).then(res => {
            if (res.data.length > 0) {
                this.setState({ Branch_txt: res.data[0].MYNAMETH });
                this.setState({ SiteCode_code: res.data[0].CODE });
                this.Branch.current.value = res.data[0].MYNAMETH;
                this.setState({ openBackdrop: false })
            } else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่พบข้อมูล" })
                this.setState({ Branch_txt: "" });
                this.setState({ SiteCode_code: "" });
                this.Branch.current.value = "";
                this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log(error);
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" })
            this.setState({ openBackdrop: false })
        });
    }
    SetPopup = (e) => {
        // this.setState({ OtPopupType: data })
        // this.setState({ showPopupOT: !this.state.showPopupOT });
        //ชื่อ
        this.setState({ OtPopupType: e })
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        if (e === "Groupdata") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" })
        }
        if (e === "Department") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" })
        }
        if (e === "Branch") {
            this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" })
        }
    }
    Switch_PopupArcode = (e) => {
        this.setState({ SwitchPopupArcode: !this.state.SwitchPopupArcode });
    }
    Switch_OtherPopup = (type) => {
        this.setState({ OtPopupType: type })
        this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    }
    Switch_PopUpSaveMoney = (e) => {
        this.setState({ PopUpSaveMoney: !this.state.PopUpSaveMoney });
    }

    Get_PopUparcode = (data1, data2) => {
        this.APCode.current.value = data1.trim();
        this.APName.current.value = data2;
    }
    Get_PopupApcode = (APCode, APName) => {
        this.CloseDialog(false)
        this.APCode.current.value = APCode
        this.APName.current.value = APName
    }
    Get_PopUpOther = async (val) => {
        this.CloseDialog(false)
        var data = val.split("|");
        for (var i = 0; i < data.length; i++) {
            data[i] = data[i].trim();
        }
        switch (this.state.OtPopupType) {
            case "Groupdata":
                console.log(data);
                this.Groupdata_code.current.value = data[0]
                this.Groupdata.current.value = data[1]
                this.setState({ Groupdata_txt: data[1] });
                await Chackdocno(data[0], "CSPAYMENT").then(async (result1) => {
                    if (result1 !== undefined) {
                        this.DeliNumber.current.value = await result1
                    } else {
                        this.DeliNumber.current.value = ""
                    }
                }).catch((err) => {
                    this.DeliNumber.current.value = ""
                    console.log(err);
                });
                break;
            case "Department":
                this.Department_code.current.value = await data[0];
                this.Department.current.value = await data[1];
                this.setState({ Department_txt: data[1] });
                break;
            case "Branch":
                this.Branch_code.current.value = await data[0];
                this.Branch.current.value = await data[1];
                this.setState({ Branch_txt: data[1] });
                break;
            default:
                break;
        }
    };
    PopUpOtherClose = (data) => {
        this.setState({ showPopupOT: !this.state.showPopupOT });
    }
    onClickDocNo = (code) => {
        if (code) {
            var url = "CSDOCGROUP/Code?tablename=CSPAYMENT&code=" + code;
            console.log(genURL("CSDOCGROUP", url));
            axios.get(genURL(url)).then(res1 => {
                console.log(res1);
                if (res1.data.length > 0) {
                    var Url1 = "CSMAXDOC/MAXDOC?tablename=CSPAYMENT&code=" + res1.data[0].CODE;
                    console.log(genURL(Url1));
                    axios.get(genURL(Url1)).then(res => {
                        if (res !== "error") {
                            this.DeliNumber.current.value = res.data["maxdoc"];
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            return
                        }
                    });
                }
            });
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ไม่พบข้อมูล" })
            this.DeliNumber.current.value = "";
        }
    }
    onRowClick = (row, col, id) => {
        // let T_Payment = row.T_Payment // จำนวนเต็มเวลาคลิก
        // if (col === 6 && T_Payment !== "" && T_Payment !== undefined) {
        //     row.T_Payment = parseFloat(T_Payment).toFixed(0)
        // }
    }

    afterSaveCell = (row, cellName, cellValue) => {
        console.log("afterSaveCell");
        var data = this.state.tableData;
        if (cellName === "T_Payment") {
            var REFAMOUNT = Number(row.REFAMOUNT)
            var T_Payment = Number(row.T_Payment)
            var sum = 0
            if (T_Payment >= REFAMOUNT) {
                row.T_Payment = parseFloat(REFAMOUNT).toFixed(2)
                row.T_Overdue = parseFloat(REFAMOUNT).toFixed(2)
            } else if (T_Payment < REFAMOUNT) {
                sum = REFAMOUNT - T_Payment
                row.T_Payment = parseFloat(T_Payment).toFixed(2)
                row.T_Overdue = parseFloat(sum).toFixed(2)
            }
            //--------------------------------------- คำนวณเงินใหม่ -------------------------------------------------------------- 
            setTimeout(() => {
                this._calprice()
            }, 30);
        }
    }
    int_format = (int) => {
        var re = 0;
        if (int) {
            re = parseFloat(int).toFixed(2);
        } else {
            re = parseFloat(re).toFixed(2);
        }
        return re;
    }

    Getformatdatetime = (date) => {
        if (date) {
            var year = date.substring(6, 10);
            var month = date.substring(3, 5);
            var day = date.substring(0, 2);
            if (year > 2500) {
                year = year - 543;
            }
            return year + month + day;
        } else {
            return "";
        }
    }
    // saveData = (CashReceipt, BOOKNO, BANKAMOUNT, BANKEXPEND, remarkcashreceipt, data3, data4, _orterExpenses) => {
    get_PopUpSaveMoney = async (cash, cchqsarr, csrexpensesarr, csrecincomarr) => {
        this.CloseDialog(false)
        let Cchqssum = 0
        let Expensessum = 0
        let Incomesum = 0
        cchqsarr.forEach(element => {
            Cchqssum += Number(element.Chqamount)
        });
        csrexpensesarr.forEach(element => {
            Expensessum += Number(element.Expensesamount)
        });
        csrecincomarr.forEach(element => {
            Incomesum += Number(element.IncomeAmount)
        });
        await this.setState({
            CashReceipt: cash[0].Cashbalance,//เงินสด
            Bookno: cash[0].Bookno, //เลขบัญชี
            Bankamount: cash[0].Bankamount, //ยอดเงินโอน
            Bankexpend: cash[0].Bankexpend, //ค่าธรรมเนียมจ่ายหักบัญชี
            Bookdesc: cash[0].Transferremark,
            Expenses: csrexpensesarr,
            Expensessum: Expensessum,
            Advanceamount: cash[0].Advanceamount,
            Pettycashcode: cash[0].Pettycashcode,
            Pettycash: cash[0].Pettycashvalue,
            Cchqssum: Cchqssum,
            Cchqs: cchqsarr,
            Income: csrecincomarr,
            Incomesum: Incomesum
        })
        await this.saveData()
    }
    Chkinputtax = async () => {
        let Chkinputtaxitem = []
        var sinputtax = []
        var beforetax = 0
        if (this.state.inputtax.length > 0) {
            for (var i = 0; i < this.state.inputtax.length && this.state.inputtax[i].Taxinvoice; i++) {
                beforetax += Number(this.state.inputtax[i].Amountbeforetax)
                sinputtax[i] = {
                    Taxinvoice: this.state.inputtax[i].Taxinvoice,
                    Invoicedate: (Moment(this.state.inputtax[i].Invoicedate, 'DD/MM/YYYY').add(-543, 'year').format('YYYY-MM-DD')),
                    PayableCode: this.state.inputtax[i].PayableCode,
                    PayableName: this.state.inputtax[i].PayableName,
                    Taxdescription: this.state.inputtax[i].Taxdescription,
                    Amountbeforetax: this.state.inputtax[i].Amountbeforetax,
                    Tax: this.state.inputtax[i].Tax,
                    Taxincluded: this.state.inputtax[i].Taxincluded,
                    Refundablerate: this.state.inputtax[i].Refundablerate,
                    Refundablevalue: this.state.inputtax[i].Refundablevalue,
                    Refundabletax: this.state.inputtax[i].Refundabletax
                }
                Chkinputtaxitem.push(sinputtax[i]);
            }
        }
        await this.setState({ beforetax: beforetax })
        return await Chkinputtaxitem
    }
    Chkcspayitemwtax = async () => {
        let rpayitemwtax = []
        var payitemwtax = []

        if (this.state.Payfirservice.length > 0) {
            for (var i = 0; i < this.state.Payfirservice.length && this.state.Payfirservice[i].Productcode; i++) {

                payitemwtax[i] = {
                    Amount: this.state.Payfirservice[i].Amount,
                    Incometype: this.state.Payfirservice[i].Incometype,
                    Itemtaxtype: this.state.Payfirservice[i].Itemtaxtype.toString(),
                    Payamount: this.state.Payfirservice[i].Payamount,
                    Paybalance: this.state.Payfirservice[i].Paybalance,
                    Productcode: this.state.Payfirservice[i].Productcode,
                    Productname: this.state.Payfirservice[i].Productname,
                    Refdocno: this.state.Payfirservice[i].Refdocno,
                    Refdoctype: this.state.Payfirservice[i].Refdoctype.toString(),
                    Reflineid: this.state.Payfirservice[i].Reflineid,
                    Wtaxamount: this.state.Payfirservice[i].Wtaxamount,
                    Wtaxrate: this.state.Payfirservice[i].Wtaxrate.toString(),
                    Taxamount: this.state.Payfirservice[i].Taxamount
                }
                rpayitemwtax.push(payitemwtax[i]);
            }
        }
        return await rpayitemwtax
    }
    Chkcsapwtax = async () => {//tab หัก ณ ที่จ่าย
        let apwtax = []
        var apwtaxitem = []
        console.log("this.state.Withholding");
        console.log(this.state.Withholding);

        // return


        if (this.state.Withholding.length > 0) {
            for (var i = 0; i < this.state.Withholding.length && this.state.Withholding[i].Taxinvoice; i++) {
                apwtaxitem[i] = {
                    Actingonbehalf: this.state.Withholding[i].Actingonbehalf,
                    Amountbeforetax: this.state.Withholding[i].Amountbeforetax.toString(),
                    Datetime: this.state.Withholding[i].Invoicedate,
                    Deduction: this.state.Withholding[i].Invoicedate,
                    Incometypecode: this.state.Withholding[i].Incomecode,
                    PayableCode: this.state.Withholding[i].PayableCode,
                    PayableName: this.state.Withholding[i].PayableName,
                    Remark: this.state.Withholding[i].Remark,
                    Tax: this.state.Withholding[i].Tax,
                    Taxinvoice: this.state.Withholding[i].Taxinvoice,
                    Taxrate: this.state.Withholding[i].Taxrate,
                    Taxtype: this.state.Withholding[i].WithholdingTypecode,
                    Taxtypetxt: this.state.Withholding[i].WithholdingType,
                    Condition: this.state.Withholding[i].Condition
                }
                apwtax.push(apwtaxitem[i]);
            }
        }
        return await apwtax
    }
    saveData = async () => {
        const parameter = new URLSearchParams();
        var dataTT = [];
        var s = [];
        for (var i = 0; i < this.state.tableData.length && this.state.tableData[i].REFDOCNO; i++) {
            dataTT[i] = {
                Refdocno: this.state.tableData[i].REFDOCNO,
                Reftaxno: (this.state.tableData[i].REFTAXNO ? this.state.tableData[i].REFTAXNO : ""),
                Refdocdate: Moment(this.state.tableData[i].REFDOCDATE, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                Refdudate: Moment(this.state.tableData[i].REFDUEDATE, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                Debtamount: this.state.tableData[i].DEBTAMOUNT,
                T_payment: this.state.tableData[i].T_Payment,
                T_Overdue: this.state.tableData[i].T_Overdue,
                Remark: this.state.tableData[i].REMARK,
                Transname: this.state.tableData[i].TRANSNAME,
                T_Paybill: this.state.tableData[i].T_Paybill ? this.state.tableData[i].T_Paybill : "",
                Refdoctype: (this.state.tableData[i].REFDOCTYPE ? this.state.tableData[i].REFDOCTYPE.toString() : ""),
                Prepaymentno: (this.state.tableData[i].PREPAYMENTNO ? this.state.tableData[i].PREPAYMENTNO : "") //มาจากเลือกใบเตรียมจ่าย
            }
            s.push(dataTT[i])
        }
        parameter.append("listitem", JSON.stringify(s));

        var POSTBALANCE = ""
        if (Number(this.state.Bankexpend) > 0) {
            POSTBALANCE = "0"
        }
        if (Number(this.bathprofit.current.value) > 0) {
            POSTBALANCE = "0"
        }
        if (this.Groupdata_code.current.value === "AI0001") {
            POSTBALANCE = "0"
        }

        //ยอดเงินสดจ่าย
        //เงินสด
        parameter.append("CASHAMOUNT", checkData("money", this.state.CashReceipt))
        //เงินทดลองจ่าย
        parameter.append("POSTBALANCE", POSTBALANCE);
        parameter.append("ADVANCEPAYBAL", this.state.Advanceamount ? this.state.Advanceamount : "");
        parameter.append("ADVANCEPAY", this.state.Advanceamount ? this.state.Advanceamount : "");
        // parameter.append("CASHAMOUNT", checkData("money", this.state.CashReceipt2))
        parameter.append("PETTYCASHCODE", this.state.Pettycashcode ? this.state.Pettycashcode : "");
        parameter.append("PETTYCASH", this.state.Pettycash ? this.state.Pettycash : "");
        //จ่ายเงินโอนผ่านบัญชี
        parameter.append("BOOKNO", checkData("text", this.state.Bookno))
        parameter.append("BANKAMOUNT", checkData("money", this.state.Bankamount))
        parameter.append("BANKEXPEND", checkData("money", this.state.Bankexpend))
        parameter.append("BOOKDESC", checkData("text", this.state.Bookdesc))

        // เช็คธนาคาร
        parameter.append("CSPAYCHQ", JSON.stringify(this.state.Cchqs))
        parameter.append("CHEQUEAMOUNT", typeof this.state.Cchqssum === "undefined" ? '0' : this.state.Cchqssum)
        parameter.append("CSRECINCOME", JSON.stringify(this.state.Income))
        parameter.append("INCOMEAMOUNT", !this.state.Incomesum ? "" : this.state.Incomesum)
        parameter.append("CSRECEXPENSE", JSON.stringify(this.state.Expenses))
        parameter.append("EXPENDAMOUNT", this.state.Expensessum)


        parameter.append("APCODE", this.APCode.current.value);
        parameter.append("APNAME", this.APName.current.value);
        parameter.append("DOCDATE", this.state.Docdate);
        parameter.append("DOCGROUP", this.Groupdata_code.current.value);
        parameter.append("DOCNO", this.DeliNumber.current.value);
        parameter.append("SALECODE", this.SALECODE_CODE.current.value);
        parameter.append("CURRENCYCODE", 'TH');
        parameter.append("EXCHANGERATE", '1.0000000');
        parameter.append("DEPARTMENT", this.Department_code.current.value);
        parameter.append("SITECODE", this.Branch_code.current.value);
        parameter.append("BATHPAYAMOUNT", checkData("money", this.Netpayamount.current.value))
        parameter.append("BATHPAYAMOUNT1", this.bathpayamount1.current.value);
        parameter.append("BATHPAYAMOUNT2", this.bathpayamount2.current.value);
        parameter.append("BATHPROFIT", this.bathprofit.current.value);
        parameter.append("BATHDEPOPAY1", this.bathprofit.current.value);
        parameter.append("BATHDEPOPAY2", this.bathprofit.current.value);
        parameter.append("bathloss", this.bathloss.current.value);
        parameter.append("REMARK", this.Remark.current.value);
        parameter.append("PROJECT", this.state.PROJECT)
        parameter.append("SUMPAYAMOUNT", this.Sumpayamount.current.value);
        parameter.append("DISCAMOUNT", this.Discamount.current.value);
        parameter.append("DEPOSITPAYMENT", this.Depositpayment.current.value);
        parameter.append("NETPAYAMOUNT", this.Netpayamount.current.value);
        parameter.append("BATHDISCAMOUNT", this.Discamount.current.value);
        parameter.append("CREATEUSER", localStorage.getItem('Username'));
        parameter.append("UPDATEUSER", localStorage.getItem('Username'));
        parameter.append("USERCODE", localStorage.getItem('Username'));
        // parameter.append("Remakcase", typeof this.state.Remakcase === undefined ? "" : this.state.Remakcase);
        parameter.append("sumallmoney", this.state._sumamountC5_s)
        //บันทึกภาษีหัก ณ ที่จ่าย

        let CSPAYITEMWTAX = []
        await this.Chkcspayitemwtax().then((result) => {
            console.log(result);
            if (result) {
                CSPAYITEMWTAX = result
            }
        })
        console.log("JSON.stringify(CSPAYITEMWTAX)", JSON.stringify(CSPAYITEMWTAX))
        // return
        parameter.append("CSPAYITEMWTAX", JSON.stringify(CSPAYITEMWTAX));
        parameter.append("WTAXAMOUNT", this.state.Wtaxamount ? this.state.Wtaxamount : "");
        // parameter.append("CSPAYITEMWTAX",this.state.Payfirservice);

        // ภาษีหัก ณ ที่จ่าย
        let CSAPWTAX = []
        await this.Chkcsapwtax().then((result) => {
            console.log(result);
            if (result) {
                CSAPWTAX = result
            }
        })
        parameter.append("CSAPWTAX", JSON.stringify(CSAPWTAX));
        // parameter.append("...",this.state.Withholding);
        //บันทึกใบกำกับภาษีหลายใบ
        let datainputtax = []
        await this.Chkinputtax().then((result) => {
            console.log("Chkinputtax", result);
            datainputtax = result
        })
        await parameter.append("muntitaxinput", JSON.stringify(datainputtax))
        parameter.append("BEFORETAX", this.state.totalpayment ? this.state.totalpayment : "")
        //parameter.append("...",this.state.Refundablerate);
        //parameter.append("...",this.state.Refundablevalue);
        parameter.append("TAXAMOUNT", this.state.Totaltax ? this.state.Totaltax : "")
        // parameter.append("...",this.state.Totaltax); 
        //หักเงินมัดจำ  
        parameter.append("CSAPDEPOSITUSE", JSON.stringify(this.state.tbCsapdeposit));
        var Uststus = true;
        for (var pair of parameter.entries()) {
            console.log(pair[0], "==", pair[1]);
            if (pair[1] === "" && pair[0] === "DOCNO") {
                Uststus = false;
            }
        }
        if (Uststus === false) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ข้อมูลไม่ครบ" })
        } else if (Uststus === true) {

            //return 
            this.setState({ openBackdrop: true })

            await axios.post(genpostURL("CSPAYMENT/Save?="), parameter).then(res => {
                // await axios.post(genURLTEST("Save?="), parameter).then(res => {
                if (res.data.status === "success") {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "success" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกสำเร็จ" })
                    setTimeout(() => {
                        this.ResetThisPage("SAVE");
                        // this.setState({ openBackdrop: false })
                    }, 300);
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "บันทึกไม่สำเร็จ " + res.data.status })
                    // this.setState({ openBackdrop: false })
                }
            }).catch(error => {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
                // this.setState({ openBackdrop: false })
            }).finally(_ => {
                this.setState({ openBackdrop: false })
            });
        }
    }
    chkdata = (data) => {
        var redata = "";
        if (data !== "null") {
            redata = data;
        }
        return redata;
    }
    SetPopUpPrereceipt = () => {
        if (this.APCode.current.value) {
            this.setState({ showPopUpPrereceipt: !this.state.showPopUpPrereceipt });
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาใส่! รหัสลูกหนี้" })
        }
    }
    REFDOCTYPE_TXT = (data) => {
        switch (data) {
            case "0":
                return "บิลขายเชื่อ"
            case "1":
                return "ลดหนี้การค้า"
            case "2":
                return ""
            case "3":
                return "ตั้งหนี้อื่นๆ"
            case "4":
                return "ลดหนี้อื่นๆ"
            case "5":
                return "ตั้งหนี้ยกมา"
            default: break;
        }
    }
    PopUpPrereceipt = () => {
        this.setState({ showPopUpPrereceipt: !this.state.showPopUpPrereceipt });
    }

    ResetDocSent = () => {
        window.location.reload();
    }
    _print = (e) => {
        // console.log("xxxx"+this.DeliNumber.current.value); 
        if (!this.DeliNumber.current.value) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกเลขที่เอกสาร" })
        } else {
            this._callForm(this.DeliNumber.current.value);
        }
    }
    _callForm = (vel) => {
        let url1 = "https://csrpt.pspl.co.th/jasperserver/flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FCSARRECEIPT&standAlone=true&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf&docno=" + vel;
        this.setState({ urlsend: url1 })
        setTimeout(() => {
            this.switchshowform();
        }, 100);
    }
    switchshowform = (e) => {
        this.setState({ showform: !this.state.showform });
    }
    _saveConnection = () => {
        if (this.state.tableData.length === 0) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกรายการ" })
            this.setState({ Uststus: false });
            return;
        } else if (this.APCode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.DOCGROUP_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.Department_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกแผนก" })
            this.setState({ Uststus: false });
            return;
        } else if (this.state.SiteCode_code === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณาเลือกสาขา" })
            this.setState({ Uststus: false });
            return;
        } else {
            this.setState({ Uststus: true });
            this.state.PopUpSaveMoney = true;
        }
    }

    onAddValue = async (type, value, Fix) => {
        if (value) {
            switch (type) {
                case "Groupdata":
                    var url = "CSDOCGROUP/Code?tablename=CSPAYMENT&code=" + value;
                    console.log(genURL(url));
                    await axios.get(genURL(url), { timeout: 3600 }).then(async (result) => {
                        if (result !== "") {
                            this.Groupdata_code.current.value = value
                            this.Groupdata.current.value = result.data[0].MYNAMETH
                            this.setState({ Groupdata_txt: result.data[0].MYNAMETH });
                            if (Fix !== "Y") {
                                await Chackdocno(value, "CSPAYMENT").then((result1) => {
                                    if (result1 !== "") {
                                        this.DeliNumber.current.value = result1
                                    } else {
                                        this.DeliNumber.current.value = ""
                                    }
                                }).catch((err) => {
                                    this.DeliNumber.current.value = ""
                                    console.log(err);
                                });
                            } else {

                            }
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Groupdata_code.current.value = ""
                            this.Groupdata.current.value = ""
                            this.setState({ Groupdata_txt: "" });
                            this.DeliNumber.current.value = ""
                        }
                    }).catch((err) => {
                        this.Groupdata_code.current.value = ""
                        this.Groupdata.current.value = ""
                        this.setState({ Groupdata_txt: "" });
                        this.DeliNumber.current.value = ""
                        console.log(err);
                    });
                    break;
                case "APCode":
                    await ChackAp(value).then((result) => {
                        console.log(result);
                        if (result !== "") {
                            let data = result.split("|")
                            this.APCode.current.value = value
                            this.APName.current.value = data[0]
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.APCode.current.value = ""
                            this.APName.current.value = ""
                        }
                    }).catch((err) => {
                        this.APCode.current.value = ""
                        this.APName.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Csuser":
                    await CheckUser(value).then((result) => {
                        if (result !== undefined) {
                            this.SALECODE_CODE.current.value = value
                            this.SALECODE.current.value = result
                        } else {
                            // AlertPopup("Warning", "ไม่พบข้อมูล!");
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูลพนักงานกรุณาลองใหม่อีกครั้ง" })

                            this.SALECODE_CODE.current.value = ""
                            this.SALECODE.current.value = ""
                        }
                    }).catch((err) => {
                        this.SALECODE_CODE.current.value = ""
                        this.SALECODE.current.value = ""
                        console.log(err);
                    });
                    break;
                case "Department":
                    await CheckDepartmentname(value).then((result) => {
                        if (result !== "") {
                            this.Department_code.current.value = value
                            this.Department.current.value = result
                            this.setState({ Department_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Department_code.current.value = ""
                            this.Department.current.value = ""
                            this.setState({ Department_txt: "" });
                        }
                    }).catch((err) => {
                        this.Department_code.current.value = ""
                        this.Department.current.value = ""
                        this.setState({ Department_txt: "" });
                        console.log(err);
                    });
                    break;
                case "Branch":
                    await CheckBrabchname(value).then((result) => {
                        if (result !== "") {
                            this.Branch_code.current.value = value
                            this.Branch.current.value = result
                            this.setState({ Branch_txt: result });
                        } else {
                            this.setState({ opensnackbar: true })
                            this.setState({ color: "warning" })
                            this.setState({ icon: ErrorIcon })
                            this.setState({ messagealert: "ไม่พบข้อมูล" })
                            this.Branch_code.current.value = ""
                            this.Branch.current.value = ""
                            this.setState({ Branch_txt: "" });
                        }
                    }).catch((err) => {
                        this.Branch_code.current.value = ""
                        this.Branch.current.value = ""
                        this.setState({ Branch_txt: "" });
                        console.log(err);
                    });
                    break;
                default: break;
            }
        }
    };

    Chackdoc = () => {
        Chackdocno(this.Groupdata_code.current.value, "CSPAYMENT").then(async (result1) => {
            if (result1 !== undefined) {
                this.DeliNumber.current.value = await result1
            } else {
                this.DeliNumber.current.value = ""
            }
        }).catch((err) => {
            this.DeliNumber.current.value = ""
            console.log(err);
        });
    }
    CloseDialog = (e) => {
        this.setState({ openFullScreenDialog: e })
    }
    ReturnData = async (e) => {
        console.log("eeeeee", e);
        var selectpopup = this.state.selectpopup
        if (selectpopup === "PopUpSearchPspayment") {
            console.log(e[1]);
        }
        console.log(e);
        switch (e[1]) {
            case "Invdebt":
                this.settoTable(e[2])
                break;
            case "Csprepayment":
                this.settoTable1(e[2])
                break;
            default:
                break;
        }
        if (selectpopup === "Inputtax") {
            this.setState({ openFullScreenDialog: e[0] })

            if (e !== "") {
                this.setState({ inputtax: e[1] })
                this.setState({ Refundablerate: e[2] })
                this.setState({ Refundablevalue: e[3] })
                this.setState({ Taxrefund: e[4] })
                this.setState({ Totaltax: e[5] })
            } else {
                this.setState({ inputtax: this.state.inputtax })
                this.setState({ Refundablerate: this.state.Refundablerate })
                this.setState({ Refundablevalue: this.state.Refundablevalue })
                this.setState({ Taxrefund: this.state.Taxrefund })
                this.setState({ Totaltax: this.state.Totaltax })
            }

        }
        if (selectpopup === "withholdingtax") {
            this.setState({ openFullScreenDialog: e[0] })
            console.log("withholdingtax ReturnData", e);
            if (e !== "") {
                if (e[1]) {
                    //   this.setState({ Docgroupcode0: e[1].Docgroupcode0 })
                    this.setState({ Wtaxamount: e[1].Totaltax0 })
                }
                if (e[2]) {
                    this.setState({ PaymentDocno: e[2].PaymentDocno })
                    this.setState({ Totaltax1: e[2].Totaltax1 })
                    this.setState({ Vat: e[2].Vat })
                    this.setState({ Payfirservice: e[2].payfirservice })

                    var sinputtax = []
                    console.log(e[2].Totaltax1, e[2].Vat);
                    if (Number(e[2].Totaltax1) > 0 && Number(e[2].Vat) > 0) {
                        console.log("dddd");
                        for (let i = 0; i < 30; i++) {
                            console.log(i);
                            sinputtax[0] = await {
                                numrow: 1,
                                Taxinvoice: "",
                                Invoicedate: this.state.Docdate,
                                PayableCode: this.APCode.current.value,
                                PayableName: this.APName.current.value,
                                Taxdescription: "",
                                Amountbeforetax: e[2].Totaltax1,
                                Tax: e[2].Vat,
                                Taxincluded: this.Sumpayamount.current.value,
                            }
                            if (i > 0) {
                                sinputtax[i] = await {
                                    numrow: i + 1,
                                    Taxinvoice: "",
                                    Invoicedate: "",
                                    PayableCode: "",
                                    PayableName: "",
                                    Taxdescription: "",
                                    Amountbeforetax: "",
                                    Tax: "",
                                    Taxincluded: "",
                                }
                            }
                        }
                    }
                    console.log(sinputtax);
                    this.setState({
                        Refundablerate: 0,
                        Refundablevalue: 0,
                        Taxrefund: 0,
                        Totaltax: e[2].Vat,
                        inputtax: sinputtax,
                        totalpayment: e[2].Totaltax1

                    })


                }
                if (e[3]) {
                    // console.log("e[3].Withholding", e[3].withholding);
                    this.setState({ Withholding: e[3].withholding })
                }
            }
        }
        if (selectpopup === "Csapdeposit") {
            this.setState({ openFullScreenDialog: e[0] })
            if (e !== "") {
                if (e[2]) {
                    this.setState({ tbCsapdeposit: e[2] })
                    console.log(e[2]);
                    let sum = 0
                    for (let i = 0; i < e[2].length; i++) {
                        sum += Number(e[2][i].DEBTAMOUNT)
                    }
                    this.setState({ sumsapdeposit: sum })
                    this._calprice()
                }
            }
        }
    }

    settoTable = async (data) => {
        console.log("settotable", data);
        this.setState({ openFullScreenDialog: false })
        if (data.length) {
            this.onAddValue("Department", data[0].department);
            this.onAddValue("Branch", data[0].sitecode);
            let listdata = this.state.tableData
            var j = Number(listdata.length)
            for (let i = 0; i < data.length; i++) {
                this.setState({ PaymentDocno: data[i].REFDOCNO })
                listdata[j] = {
                    REFDOCNO: data[i].REFDOCNO,
                    REFTAXNO: data[i].REFTAXNO,
                    REFDOCDATE: ReDate(data[i].REFDOCDATE),
                    REFDUEDATE: ReDate(data[i].REFDUEDATE),
                    DEBTAMOUNT: data[i].DEBTBALANCE,
                    T_Payment: data[i].DEBTBALANCE,
                    T_Overdue: (/* data[i].PAYTAXAMOUNT != '0.00' && data[i].PAYTAXAMOUNT ? data[i].PAYTAXAMOUNT : */ ""),
                    REMARK: "",//data[i].REMARK
                    T_Paybill: data[i].T_Paybill,
                    TRANSNAME: data[i].TRANSNAME,
                    REFDOCTYPE: data[i].REFDOCTYPE
                }
                j++
            }
            this.setState({ tableData: listdata })
            this._calprice()
        }
    }
    settoTable1 = async (data) => {
        this.setState({ openFullScreenDialog: false })
        console.log(data);
        if (data.length > 0) {
            //รวมเงินสด
            this.setState({ Cashbalance: data[0].CASHAMOUNT })
            this.setState({ CashReceipt2: data[0].ADVANCEPAY })
            this.setState({ Pettycashcode: data[0].PETTYCASHCODE })
            this.setState({ Pettycash: data[0].PETTYCASH })
            //รวมจ่ายเงินโอน
            this.setState({ Bookno: data[0].BOOKNO })
            this.setState({ Bankamount: data[0].BANKAMOUNT })
            this.setState({ Bankexpend: data[0].BANKEXPEND })
            this.setState({ BookDESC: data[0].BOOKDESC })
            //บัตรเครดิต
            this.checkcspaychq(data[0].DOCNO)
            //รายได้อื่นๆ
            this.checkcsprepayincome(data[0].DOCNO, "CSPREPAYINCOME")
            //ค่าใช้จ่ายอื่นๆ
            this.checkcsprepayexpenses(data[0].DOCNO, "CSPREPAYEXPENSE")

            this.setState({ PaymentDocno: data[0].DOCNO })
            this.onAddValue("Department", data[0].DEPARTMENT);
            this.onAddValue("Branch", data[0].SITECODE);

            let listdata = this.state.tableData
            var j = Number(listdata.length)
            let url = "CSPREPAYMENTSUB/GET?DOCNO=" + data[0].DOCNO
            console.log(genURL(url));
            await axios.post(genURL(url)).then(res => {
                for (let i = 0; i < res.data.length; i++) {
                    var DOCDATE = res.data[i].DOCDATE.split('T')
                    var REFDOCDATE = res.data[i].REFDOCDATE.split('T')
                    listdata[j] = {
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFTAXNO: res.data[i].REFTAXNO,
                        REFDOCDATE: res.data[i].DOCDATE ? DOCDATE[0] : "",
                        REFDUEDATE: res.data[i].REFDOCDATE ? REFDOCDATE[0] : "",
                        DEBTAMOUNT: res.data[i].PAYAMOUNT,
                        T_Payment: res.data[i].PAYBALANCE,
                        T_Overdue: (res.data[i].PAYTAXAMOUNT != '0.00' && res.data[i].PAYTAXAMOUNT ? res.data[i].PAYTAXAMOUNT : ""),
                        REMARK: '',
                        T_Paybill: (!res.data[i].PAYBILLNO || res.data[i].PAYBILLNO === null ? "" : res.data[i].PAYBILLNO),
                        TRANSNAME: this.REFDOCTYPE_TXT(res.data[i].REFDOCTYPE.toString()),
                        REFDOCTYPE: res.data[i].REFDOCTYPE,
                        PREPAYMENTNO: res.data[i].DOCNO,
                    }
                    j++
                }
            }
            )
            this.setState({ tableData: listdata })
            this._calprice()
        }
    }
    checkcspaychq = (docno) => {
        var col = []
        var Creditsum = 0
        let url = "CSPAYCHQ/Search?Tablename=CSPAYMENT&Docno=" + docno
        console.log(genURL(url));
        axios.post(genURL(url)).then(res => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length + 9; i++) {
                    if (i < res.data.length) {
                        col[i] = {
                            C0: i + 1,
                            C1: res.data[i].CHEQUENO,
                            C1_1: res.data[i].PK_CHEQUENO,
                            C2: res.data[i].CHQAMOUNT,
                            C3: res.data[i].BOOKNO,
                            C4: Moment(res.data[i].DUEDATE, 'YYYY-MM-DD').add(543, "year").format('DD/MM/YYYY'),
                            C5: res.data[i].CHQPAY,
                            C6: res.data[i].REMARK,
                            C7: res.data[i].PAYCHQTO,
                        }
                    } else {
                        col[i] = {
                            C0: i + 1,
                        }
                    }
                }
                var tbCredit = [];
                var Credit = [];
                for (let i = res.data.length - 1; i >= 0; i--) {
                    let DUEDATE = Moment(res.data[i].DUEDATE, 'YYYY-MM-DD').add(543, "year").format('DD/MM/YYYY')
                    tbCredit[i] =
                        res.data[i].CHEQUENO + "|" +//0
                        res.data[i].BOOKNO + "|" +//2
                        DUEDATE + "|" +//3
                        res.data[i].CHQPAY + "|" +//4
                        res.data[i].CHQAMOUNT + "|" +//1
                        res.data[i].REMARK + "|" +//5
                        res.data[i].PAYCHQTO + "|" +//6
                        res.data[i].PK_CHEQUENO      //7
                    Credit.push(tbCredit[i]);
                    Creditsum += Number(res.data[i].CHQAMOUNT)
                }
            }
        })
        this.setState({ Credit1: col })
        this.setState({ Creditsum: Creditsum })
        this.setState({ Credit: col })
    }
    checkcsprepayincome = (docno, nametb) => {
        var tbotherincome = [];
        var col = []
        let Incomesum = 0
        let table = nametb
        // let url = "CSPAYMENT/" + table + "?Docno=" + docno
        let url = table + "/Search?&Docno=" + docno
        if (table = "CSRECINCOME") {
            url = "CSRECINCOME/Search?Tablename=CSPAYMENT&Docno=" + docno
        }
        console.log(genURL(url));
        axios.post(genURL(url)).then(async res => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length + 9; i++) {
                    if (i < res.data.length) {
                        let Nameincome = ""
                        await checkincome(res.data[i].INCOME).then((result) => {
                            Nameincome = result
                        })
                        col[i] = {
                            C0: i + 1,
                            BTN: "delect",
                            C1: res.data[i].INCOME,
                            C2: Nameincome,
                            C3: res.data[i].REMARK,
                            C4: res.data[i].AMOUNT,
                        }
                    } else {
                        col[i] = {
                            C0: i + 1,
                            BTN: 1,
                        }
                    }
                }
                var Income = [];
                for (var i = 0; i < res.data.length; i++) {
                    Incomesum += Number(res.data[i].AMOUNT)
                    let REMARK = !res.data[i].REMARK ? "" : res.data[i].REMARK
                    tbotherincome[i] =
                        res.data[i].INCOME + "|" +  //0
                        "|" +                       //1
                        REMARK + "|" +              //2
                        res.data[i].AMOUNT          //3
                    Income.push(tbotherincome[i]);
                }

            }
        })
        this.setState({ Income1: col })
        this.setState({ Incomesum: Incomesum })
        this.setState({ Income: tbotherincome })
    }
    checkcsprepayexpenses = (docno, nametb) => {
        let Expensessum = 0
        var Expenses = [];
        var col = []
        let table = nametb
        // let url = "CSPAYMENT/" + table + "?Docno=" + docno
        let url = table + "/Search?&Docno=" + docno
        if (table = "CSRECEXPENSE") {
            url = "CSRECEXPENSE/Search?Tablename=CSPAYMENT&Docno=" + docno
        }
        console.log(genURL(url));
        axios.post(genURL(url)).then(async res => {
            if (res.data.length > 0) {
                //ส่งกลับหน้า savemonney
                for (let i = 0; i < res.data.length + 9; i++) {
                    if (i < res.data.length) {
                        let NameExpenses = ""
                        await Checkcsexpenses(res.data[i].EXPENSE).then((result) => {
                            NameExpenses = result
                        })
                        col[i] = {
                            C0: i + 1,
                            BTN: "delect",
                            C1: res.data[i].EXPENSE,
                            C2: NameExpenses,
                            C3: res.data[i].REMARK,
                            C4: res.data[i].AMOUNT,
                        }
                    } else {
                        col[i] = {
                            C0: i + 1,
                            BTN: 1,
                        }
                    }
                }
                //save
                var tbExpenses = [];
                for (let i = 0; i < res.data.length; i++) {
                    Expensessum += Number(res.data[i].AMOUNT)
                    let REMARK = !res.data[i].REMARK ? "" : res.data[i].REMARK
                    tbExpenses[i] =
                        res.data[i].EXPENSE + "|" +     //0
                        "|" +                           //1
                        REMARK + "|" +                  //2
                        res.data[i].AMOUNT              //3
                    Expenses.push(tbExpenses[i]);
                }

            }
        })
        this.setState({ Expenses1: col })
        this.setState({ Expensessum: Expensessum })
        this.setState({ Expenses: Expenses })
    }
    //set popup หักเงินมัดจำ
    checkCsapdeposituse = (docno) => {
        let url = "CSAPDEPOSITUSE/Search?Tablename=CSPAYMENT&Docno=" + docno
        console.log(genURL(url));
        axios.post(genURL(url)).then(async res => {
            if (res.data.length > 0) {
                this.setState({ tbCsapdeposit: res.data })
                let sum = 0
                for (let i = 0; i < res.data.length; i++) {
                    sum += await Number(res.data[i].DEBTBALANCE)
                }
                this.setState({ sumsapdeposit: sum })
                // this._calprice()
                //555
            }
        })
    }
    checkCsinputtax = (docno, TAXAMOUNT) => {
        var sinputtax = []
        let url = "CSINPUTTAX/Search?Tablename=CSPAYMENT&Docno=" + docno
        console.log(genURL(url));
        axios.post(genURL(url)).then(async res => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length + 25; i++) {
                    if (i < res.data.length) {
                        sinputtax[i] = await {
                            // numrow: i + 1,
                            Taxinvoice: res.data[i].TAXNO,
                            Invoicedate: res.data[i].PRINTDATE,
                            PayableCode: res.data[i].APCODE,
                            PayableName: res.data[i].APNAME,
                            Taxdescription: res.data[i].REMARK,
                            Amountbeforetax: res.data[i].BEFORETAX,
                            Tax: res.data[i].TAXAMOUNT,
                            Taxincluded: res.data[i].TOTALAMOUNT,
                            B_TAXRATE: res.data[i].B_TAXRATE,
                            B_AMOUNT: res.data[i].B_AMOUNT,
                            B_TAXAMOUNT: res.data[i].B_TAXAMOUNT,
                        }
                    } else {
                        sinputtax[i] = await {
                            // numrow: i + 1,
                            Taxinvoice: "",
                            Invoicedate: "",
                            PayableCode: "",
                            PayableName: "",
                            Taxdescription: "",
                            Amountbeforetax: "",
                            Tax: "",
                            Taxincluded: "",
                        }
                    }
                }

            }
        })
        this.setState({ inputtax: sinputtax })
        this.setState({ Refundablerate: 0 })
        this.setState({ Refundablevalue: 0 })
        this.setState({ Taxrefund: 0 })
        this.setState({ Totaltax: TAXAMOUNT })
    }
    checkCspayitemwtax = (docno) => {
        let url = "CSPAYITEMWTAX/Search?&Docno=" + docno
        console.log(genURL(url));
        axios.post(genURL(url)).then(async res => {
            var row = []
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    row[i] = await {
                        AMOUNT: res.data[i].AMOUNT,
                        INCOMETYPE: res.data[i].INCOMETYPE,
                        ITEMTAXTYPE: res.data[i].ITEMTAXTYPE,
                        PAYAMOUNT: res.data[i].PAYAMOUNT,
                        PAYBALANCE: res.data[i].PAYBALANCE,
                        PRODUCTCODE: res.data[i].PRODUCTCODE,
                        PRODUCTNAME: res.data[i].PRODUCTNAME,
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFDOCTYPE: res.data[i].REFDOCTYPE,
                        REFLINEID: res.data[i].REFLINEID,
                        WTAXAMOUNT: res.data[i].WTAXAMOUNT,
                        TAXAMOUNT: res.data[i].WTAXAMOUNT,
                        WTAXRATE: res.data[i].WTAXRATE,
                    }
                }
            }
            this.setState({ Payfirservice: row })
        })
    }
    checkCsapwtax = (docno) => {
        let url = "CSAPWTAX/Search?Tablename=CSPAYMENT&Docno=" + docno
        console.log(genURL(url));
        axios.post(genURL(url)).then(async res => {
            console.log(res.data);
            if (res.data.length > 0) {
                let table = []
                for (let i = 0; i < res.data.length + 20; i++) {
                    if (i < res.data.length) {
                        let INCOMETYPE = ""
                        await this.checkincometype(res.data[i].INCOMETYPE).then(result => {
                            INCOMETYPE = result
                        })
                        let WTAXTYPE = ""
                        await this.checkwtype(res.data[i].WTAXTYPE).then(result => {
                            WTAXTYPE = result
                        })
                        table[i] = await {
                            numrow: i + 1,
                            Taxinvoice: res.data[i].RUNNING,
                            Income: INCOMETYPE,
                            Incomecode: res.data[i].INCOMETYPE,
                            Invoicedate: ReDate(res.data[i].PRINTDATE),
                            PayableCode: res.data[i].APCODE,
                            PayableName: res.data[i].APNAME,
                            Remark: res.data[i].REMARK,
                            Taxdescription: res.data[i].WTAXRATE,
                            Amountbeforetax: res.data[i].BEFORETAX,
                            Tax: res.data[i].WTAXAMOUNT,
                            PayableCode1: res.data[i].APCODE,
                            Condition: res.data[i].WTAXFLAG2,
                            Typecode: res.data[i].WTAXTYPE,
                            Type: WTAXTYPE,
                        }
                    } else {
                        table[i] = await {
                            numrow: i + 1,
                        }
                    }
                }
                this.setState({ withholding: table })
            }
        })
    }
    checkincometype = async (code) => {
        let rs = ""
        if (code) {
            var url = "CSINCOMETYPE/Search?Code=" + code
            console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 5000 }).then((res) => {
                if (res.data.length > 0) {
                    rs = res.data[0].MYNAMETH
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        return await rs
    }
    checkwtype = async (code) => {
        let rs = ""
        if (code) {
            var url = "CSWTAXTYPE/Search?Code=" + code
            console.log(genURL(url));
            await axios.get(genURL(url), { timeout: 5000 }).then((res) => {
                if (res.data.length > 0) {
                    rs = res.data[0].MYNAMETH
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        return await rs
    }

    openDialog = (e) => {
        console.log(e);
        if (e === "PopUpSearchPspayment") {
            let arrforparm = []
            this.setState({ openFullScreenDialog: true })
            this.setState({ typeFullScreenDialog: e })
            this.setState({ titleFullScreenDialog: "บันทึกจ่ายชำระหนี้" })
            this.setState({ dataforpopup: arrforparm })
            return
        }
        this.setState({ selectpopup: e })
        if (!this.APCode.current.value) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
            return
        }
        if (e === "APInvdebt") {
            this.setState({ openFullScreenDialog: true })
            this.setState({ typeFullScreenDialog: e })
            this.setState({ titleFullScreenDialog: "ค้นหาเอกสารตั้งเจ้าหนี้คงค้าง" })
            this.setState({
                dataforpopup: {
                    url: "CSV_APINVBAL/Getbehindhand?apcode=" + this.APCode.current.value,
                    type: e
                }
            })
        } else if (e === "APInvdebtpaybill") {
            this.setState({ openFullScreenDialog: true })
            this.setState({ typeFullScreenDialog: e })
            this.setState({ titleFullScreenDialog: "ค้นหาเอกสาตั้งหนี้และใบวางบิล" })
            this.setState({
                dataforpopup: {
                    url: "CSV_APINVBALPLAY/GetAPInvdebtpaybill?apcode=" + this.APCode.current.value,
                    type: e
                }
            })
        }
        if (e === "ARPaybill") {
            this.setState({ openFullScreenDialog: true })
            this.setState({ titleFullScreenDialog: "เลือกใบวางบิล-ApPaybill" })
            this.setState({ typeFullScreenDialog: e })
            this.setState({
                dataforpopup: {
                    url: "CSAPPAYBILL/GET?APCODE=" + this.APCode.current.value,
                    type: e
                }
            })
        }
        if (e === "Csprepayment") {
            this.setState({ openFullScreenDialog: true })
            this.setState({ typeFullScreenDialog: e })
            this.setState({ titleFullScreenDialog: "เลือกใบเตรียมจ่ายชำระหนี้-Prepayment" })
            this.setState({
                dataforpopup: {
                    url: "CSPREPAYMENT/GET?APCODE=" + this.APCode.current.value,
                    type: e
                }
            })
        }
        if (e === "Csapdeposit") {
            let arrforparm = {
                APCode: this.APCode.current.value,
                tbCsapdeposit: this.state.tbCsapdeposit
            }
            this.setState({ openFullScreenDialog: true })
            this.setState({ typeFullScreenDialog: e })
            this.setState({ titleFullScreenDialog: "บันทึกตัดยอดเงินมัดจำ" })
            this.setState({ dataforpopup: arrforparm })
        }
        if (e === "Inputtax") {
            let arrforparm = []
            arrforparm.push(this.state.Docdate)
            arrforparm.push(this.APCode.current.value)
            arrforparm.push(this.APName.current.value)
            arrforparm.push(7)
            // ข้อมูลในตาราง
            arrforparm.push(this.state.inputtax)
            //  อัตราขอคืนได้
            arrforparm.push(this.state.Refundablerate)
            // มูลค่าที่ขอคืนได้
            arrforparm.push(this.state.Refundablevalue)
            // ภาษีที่ขอคืนได้
            arrforparm.push(this.state.Taxrefund)
            // รวมยอดภาษี
            arrforparm.push(this.state.Totaltax)
            // this.setState({ parm: arrforparm })

            this.setState({ openFullScreenDialog: true })
            this.setState({ typeFullScreenDialog: e })
            this.setState({ titleFullScreenDialog: "เลือกใบเตรียมจ่ายชำระหนี้-Prepayment" })
            this.setState({ dataforpopup: arrforparm })
        }
        if (e === "withholdingtax") {

            let arrforparm = []
            //หน้าหลัก
            let data0 = []
            data0 = {
                Docgroupcode0: this.state.Docgroupcode0,
                Wtaxamount: this.state.Wtaxamount,
            }
            arrforparm.push(data0)
            //หน้าแรก
            let data1 = []
            var refdocno = ""
            var rowdata = this.state.tableData
            for (let i = 0; i < rowdata.length && rowdata[i].REFDOCNO; i++) {
                refdocno += rowdata[i].REFDOCNO + "|"
            }
            data1 = {
                PaymentDocno: this.state.PaymentDocno,
                Refdocno: refdocno,
                totalpayment: this.state.Totaltax1,
                Vat: this.state.Vat,
                // ข้อมูลในตาราง
                payfirservice: this.state.Payfirservice,
            }
            arrforparm.push(data1)
            //หน้าสอง
            let data2 = []
            data2 = {
                APCode: this.APCode.current.value,
                APName: this.APName.current.value,
                // ข้อมูลในตาราง
                withholding: this.state.Withholding,
            }
            arrforparm.push(data2)
            this.setState({ openFullScreenDialog: true })
            this.setState({ typeFullScreenDialog: e })
            this.setState({ titleFullScreenDialog: "บันทึกภาษีหัก ณ ที่จ่าย" })
            this.setState({ dataforpopup: arrforparm })
        }
    }
    onClick = (e) => {
        if (e.target.value !== "") {
            switch (e.target.name) {
                case "Groupdata":
                    this.Groupdata.current.value = this.Groupdata_code.current.value
                    break;
                case "Issuetype":
                    this.Issuetype.current.value = this.Issuetype_code.current.value
                    break;
                case "Department":
                    this.Department.current.value = this.Department_code.current.value
                    break;
                case "Branch":
                    this.Branch.current.value = this.Branch_code.current.value
                    break;
                default:
                    break;
            }
        }
    }
    onKeyDown = (e) => {
        if (e.key === "Enter") {
            if (e.target.name === "Groupdata") {
                this.onAddValue("Groupdata", e.target.value);
            }
            if (e.target.name === "APCode") {
                this.onAddValue("APCode", e.target.value);
            }
            if (e.target.name === "Issuetype") {
                this._chkData("Issuetype", e.target.value);
            }
            if (e.target.name === "Department") {
                this.onAddValue("Department", e.target.value);
            }
            if (e.target.name === "Branch") {
                this.onAddValue("Branch", e.target.value);
            }
        }
    };
    onChange = (e) => {
        switch (e.target.name) {
            case 'Groupdata':
                if (e.target.value === "") {
                    this.setState({ Groupdata_txt: "" })
                    this.Groupdata_code.current.value = "";
                    this.DeliNumber.current.value = "";
                }
                break;
            case 'APCode':
                if (e.target.value === "") {
                    this.APName.current.value = "";
                }
                break;
            case "Issuetype":
                if (this.Issuetype.current.value === "") {
                    this.setState({ Issuetype_txt: "" })
                    this.Issuetype_code.current.value = "";
                }
                break;
            case 'Department':
                if (e.target.value === "") {
                    this.setState({ Department_txt: "" })
                    this.state.Department_txt = ""
                }
                break;
            case 'Branch':
                if (e.target.value === "") {
                    this.setState({ Branch_txt: "" })
                    this.Branch_code.current.value = ""
                }
                break;
            default:
                break;
        }
    }
    onBlur = (e) => {
        if (e.target.name === "Groupdata") {
            this.Groupdata.current.value = this.state.Groupdata_txt;
        }
        if (e.target.name === "Issuetype") {
            this.Issuetype.current.value = this.state.Issuetype_txt;
        }
        if (e.target.name === "Department") {
            this.Department.current.value = this.state.Department_txt;
        }
        if (e.target.name === "Branch") {
            this.Branch.current.value = this.state.Branch_txt;
        }

    }
    Switch_PopupApcode = (e) => {
        //ชื่อ
        this.setState({ typeFullScreenDialog: e })
        //open
        this.setState({ openFullScreenDialog: true })
        //title
        this.setState({ titleFullScreenDialog: "ค้นหาเจ้าหนี้/ตัวแทนจำหน่าย-AP" })
    }
    handleClearButtonClick = (e) => {
        if (e) {
            // if (window.confirm('Are you sure you want to save this thing into the database?')) {
            if (window.confirm('คุณต้องการลบข้อมูลที่เลือกใช่หรือไม่')) {
                // Save it!
                console.log('Thing was saved to the database.');
                var row = []
                var j = 0
                for (let i = 0; i < this.state.tableData.length; i++) {
                    if (this.state.tableData.length > 0) {
                        if (!this.state.tableData[i].delete) {
                            row[j] = this.state.tableData[i]
                            j++
                        }
                    }
                }
                this.setState({ tableData: row })
            } else {
                // Do nothing!
                console.log('Thing was not saved to the database.');
            }
        }
    }
    indexN(cell, row, enumObject, index) {
        return (<div>{index + 1}</div>)
    }

    onRowSelect(row, isSelected, e) {
        console.log(row, isSelected);
        row.delete = isSelected

    }
    onSelectAll(isSelected, rows) {
        console.log(isSelected, rows);
        for (let i = 0; i < rows.length; i++) {
            rows[i].delete = isSelected
        }
    }
    createCustomDeleteButton = (e) => {
        return (<button style={{ color: 'red' }} onClick={() => this.handleClearButtonClick(e)}>ลบข้อมูล</button>);
    }

    Chksave = () => {

        if (this.APCode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
            return
        }
        if (this.APName.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" })
            return
        }
        if (this.DeliNumber.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลเลขที่เอกสารก่อน ...!" })
            return
        }
        if (this.Currencycode.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลสกุลเงินก่อน ...!" })
            return
        }
        if (this.exchangerate.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลอัตราแลกเปลี่ยนก่อน ...!" })
            return
        }
        if (!this.state.tableData.length) {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "คุณยังไม่ได้เลือกข้อมูล ...!" })
            return
        }
        if (this.Department_code.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลแผนก ...!" })
            return
        }
        if (this.Branch_code.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "กรุณากรอกข้อมูลสาขา ...!" })
            return
        }
        let chkmuney = (Number(this.state.Cashbalance) + Number(this.state.CashReceipt2) + Number(this.state.Pettycash) + Number(this.state.Bankamount)
            + Number(this.state.Creditsum) + Number(this.state.Incomesum)) - (Number(this.state.Bankexpend) + Number(this.state.Expensessum))
        let sum = Number(this.state.AmountPayable) - Number(this.state.Wtaxamount)
        console.log(sum, "===", chkmuney);
        if (chkmuney === sum) {
            this.saveData()
        } else {
            this.setState({ typeFullScreenDialog: "SaveMoney" })
            this.setState({ titleFullScreenDialog: "บันทึกจ่ายเงิน" })
            this.setState({ openFullScreenDialog: true })
        }
    }
    onDelete = (data0, data1, data2) => {
        console.log(data0, data1, data2);
    }

    _reCHK = async (RowData) => {
        this.CloseDialog(false)
        console.log("RowData", RowData)
        try {
            let url = "CSPAYMENT/CSPAYMENT?Docno=" + RowData[0].docNo;
            //let url = "/Getmaindata?Docno=" + RowData[0].docno;
            // console.log("url_reCHK", genURL(url));
            let data = await axios.get(genURL(url), { timeout: 3600 }).then(res => {
                return res.data
            })
            console.log("Getmaindata", data);
            if (data.length > 0) {
                this.onAddValue("Department", data[0].DEPARTMENT);
                this.onAddValue("Branch", data[0].SITECODE);
                this.onAddValue('APCode', data[0].APCODE)
                this.onAddValue('Groupdata', data[0].DOCGROUP, 'Y')
                this.Groupdata_code.current.value = data[0].DOCGROUP
                this.DeliNumber.current.value = data[0].DOCNO
            }
            let suburl = "CSPAYMENT/GetDataSub?Docno=" + RowData[0].docNo;
            //let suburl = "/Getmaindatasub?Docno=" + RowData[0].docno;
            console.log("url_reCHK", genURL(suburl));
            let listsubdata = this.state.tableData
            let Transname = ""
            await axios.get(genURL(suburl)).then(async res => {

                var j = 0
                console.log("listsubdata", listsubdata);
                for (let i = 0; i < res.data.length; i++) {
                    this.setState({ PaymentDocno: res.data[i].REFDOCNO })

                    console.log(genURL(`CSV_APINVBAL/Getcsvapinvbal/REFDOCNO/${res.data[i].REFDOCNO}?`))
                    Transname = await axios.get(genURL(`CSV_APINVBAL/Getcsvapinvbal/REFDOCNO/${res.data[i].REFDOCNO}?`)).then(res => {
                        // console.log("CSV_APINVBALurl", res);
                        let TRANSNAME = ""
                        if (res.length > 0) {
                            TRANSNAME = res.data[0].TRANSNAME
                        }
                        return TRANSNAME
                    })
                    listsubdata[j] = {
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFTAXNO: res.data[i].REFTAXNO,
                        REFDOCDATE: ReDate(res.data[i].REFDOCDATE),
                        REFDUEDATE: ReDate(res.data[i].REFDUEDATE),
                        DEBTAMOUNT: res.data[i].REFAMOUNT,
                        T_Payment: res.data[i].PAYAMOUNT,
                        T_Overdue: res.data[i].REFBALANCE,
                        REMARK: res.data[i].REMARK,
                        T_Paybill: res.data[i].PAYBILLNO,
                        TRANSNAME: Transname,
                        REFDOCTYPE: res.data[i].REFDOCTYPE,
                    }
                    j++
                }
                // return res.data
            }).finally(async _ => {
                console.log("listsubdata", listsubdata);
                await this.setState({ tableData: listsubdata })
                await this._calprice()
            })

        } catch (error) {
            console.log("Err:" + error)
        }
    }

    render() {
        const cellEditProp = {
            mode: 'click',
            blurToSave: true,
            afterSaveCell: this.afterSaveCell,
            blurToSave: true,
        }
        const options = {
            onRowClick: this.onRowClick,
            onMouseLeave: this.onMouseLeave,
            deleteBtn: this.createCustomDeleteButton
        }

        const selectRowProp = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.onRowSelect,
            onSelectAll: this.onSelectAll
        };
        const listmenu = [
            ["เลือกเอกสารตั้งหนี้คงค้าง", "APInvdebt"],
            ["เลือกเอกสาตั้งหนี้และใบวางบิล", "APInvdebtpaybill"],
            // ["เลือกใบรับวางบิล", "ARPaybill"],
            ["เลือกใบเตรียมจ่าย", "Csprepayment"],
            ["บันทึกภาษีหัก ณ ที่จ่าย", "withholdingtax"],
            ["บันทึกใบกำกับภาษีหลายใบ", "Inputtax"],
            ["จ่ายชำระหนี้", "Payoffdebt"],
            ["หักเงินมัดจำ", "Csapdeposit"],
        ]
        const onClick = (e) => {
            console.log(e);
            switch (e) {
                case "save":
                    // let chkmuney = Number(this.state.Cashbalance) + Number(this.state.BANKAMOUNT) + Number(this.state.BANKEXPEND)
                    // if (chkmuney === Number(this.state.Debtamount)) {
                    // this.saveData()
                    this.Chksave()
                    // }
                    //  else {
                    //     this.setState({ PopUpSaveMoney: true })
                    // }
                    break;
                case "new":
                    this.ResetDocSent()
                    break;
                case "print":
                    this._print.bind(null)
                    break;
                case "search":
                    this.openDialog("PopUpSearchPspayment")
                    // this.setState({ SwitchSearchDoc: true });
                    break;
                case "APInvdebt":
                    this.openDialog("APInvdebt")
                    break;
                case "APInvdebtpaybill":
                    this.openDialog("APInvdebtpaybill")
                    break;
                // case "ARPaybill":
                //     this.openDialog("ARPaybill")
                //     break;
                case "Csprepayment":
                    this.openDialog("Csprepayment")
                    break;
                case "withholdingtax":
                    this.openDialog("withholdingtax")
                    break;
                case "Inputtax":
                    this.openDialog("Inputtax")
                    break;
                case "Payoffdebt":
                    //เซตเงินสด
                    let cash = {
                        CashReceipt1: this.state.Cashbalance,
                        CashReceipt2: this.state.CashReceipt2,
                        Pettycashcode: this.state.Pettycashcode,
                        CashReceipt4: this.state.Pettycash
                    }
                    this.setState({ datacash: cash })
                    //เซตเงินโอน
                    let bank = {
                        Bookno: this.state.Bookno,
                        Bankamount: this.state.Bankamount,
                        Bankexpend: this.state.Bankexpend,
                        Remark: this.state.BookDESC
                    }
                    this.setState({ databank: bank })

                    this.setState({ typeFullScreenDialog: "SaveMoney" })
                    this.setState({ titleFullScreenDialog: "บันทึกจ่ายเงิน" })
                    this.setState({ openFullScreenDialog: true })
                    break;
                case "Csapdeposit":
                    this.openDialog("Csapdeposit")
                    break;
                default:
                    break;
            }
        }
        const type = this.state.typeFullScreenDialog
        return (

            <div className="PSApp" onClick={this.onClick} onKeyDown={this.onKeyDown} onChange={this.onChange} onBlur={this.onBlur} >

                <Backdrop open={this.state.openBackdrop} />
                <FullScreenDialog1 open={this.state.openFullScreenDialog} title={this.state.titleFullScreenDialog} closeDialog={e => this.CloseDialog(e)}>
                    {type === "SaveMoney" ?
                        <PopUpSaveMoneyExp closePopup={e => this.CloseDialog(e)}
                            AmountPayable={this.state.AmountPayable}
                            Wtaxamount={this.state.Wtaxamount}
                            date={this.state.Docdate}
                            // Customer={this.CustomerCode.current.value}
                            from="CSPAYMENT"
                            get_PopUpSaveMoney={this.get_PopUpSaveMoney}
                            pms="R|1|1|1|1|1|1" /> : null}
                    {type === "PopUpSearchPspayment" ?
                        // <PopUpSearchPspayment closePopup={() => { this.setState({ SwitchSearchDoc: !this.state.SwitchSearchDoc }) }}
                        //     resdata={this.ReplaceThisPage} from="CSPAYMENT" />
                        <Rechecked Dataselect={e => this._reCHK(e)} from="CSPAYMENT" />
                        : null}
                    {type === "APInvdebt" ? <APInvdebt parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)} /> : null}
                    {type === "APInvdebtpaybill" ? <APInvdebtpaybill parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)} /> : null}
                    {type === "Csprepayment" ? <Csprepayment parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)} /> : null}
                    {type === "withholdingtax" ? <Playmentwithholding parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)} /> : null}
                    {type === "Inputtax" ? <Inputtax parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)} recheckeddata={this.state.recheckdata} /> : null}
                    {type === "Csapdeposit" ? <Csapdeposit parm={this.state.dataforpopup} resdata={e => this.ReturnData(e)} /> : null}
                    {type === "Groupdata" || type === "Department" || type === "Branch" ? <PopUpOther closePopup={e => this.CloseDialog(e)} Get_PopUpOther={this.Get_PopUpOther} type={this.state.OtPopupType} Data={this.state.valuePopup} from="CSPAYMENT" userSite={this.state.siteCodeUser} /> : null}
                    {type === "Search_APCode" ? <PopupApcode closePopup={e => this.CloseDialog(e)} Get_PopupApcode={this.Get_PopupApcode} /> : null}
                </FullScreenDialog1>
                {this.state.showform ? (<PopUpReport close={this.switchshowform} url={this.state.urlsend} />) : null}
                {/* {this.state.PopUpSaveMoney ? <PopUpSaveMoney closePopup={this.Switch_PopUpSaveMoney} AmountPayable={this.state.AmountPayable} Wtaxamount={this.state. Wtaxamount} Customer={this.APCode.current.value} from="CSPAYMENT" get_PopUpSaveMoney={this.get_PopUpSaveMoney} pms="R|1|1|0|1|1|1" /> : null} */}
                {/* {this.state.SwitchSearchDoc ? <PopUpSearchDoc closePopup={() => { this.setState({ SwitchSearchDoc: !this.state.SwitchSearchDoc }) }} Get_Popup={this.ReplaceThisPage} from="CSPAYMENT" /> : null} */}
                {/* {this.state.SwitchPopupApcode ? (<PopupApcode closePopup={this.Switch_PopupApcode} Get_PopupApcode={this.Get_PopupApcode} />) : null} */}
                {/* {this.state.showPopupOT ? <PopUpOther closePopup={this.PopUpOtherClose} Get_PopUpOther={this.Get_PopUpOther} type={this.state.OtPopupType} Data={this.state.valuePopup} from="CSPAYMENT" userSite={this.state.siteCodeUser} /> : null} */}
                < Topbar
                    listmenu={listmenu}
                    onClick={e => onClick(e)
                    }
                    title="บันทึกจ่ายชำระหนี้"
                />
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <Row className="show-grid">
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> รหัสเจ้าหนี้  </span>
                                                <input id="1" type="text" className="form-control " name="APCode" ref={this.APCode}
                                                // tabIndex={1} onKeyPress={this.Get_Arcode.bind(null)} onBlur={this.Get_Arcode.bind(null, "APCode")} 
                                                />
                                                <span onClick={() => this.Switch_PopupApcode("Search_APCode")} id="iconAPCode" className="input-group-addon icon" >
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={8} md={8} lg={8}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span id="iconCustomerName" className="input-group-addon icon"><i className="fas fa-user"></i></span>
                                                <input id="2" type="text" className="form-control " ref={this.APName} name="APName" onKeyDown={this.onKeyPressValue} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <MaterialUIPickers title="วันที่เอกสาร" DateValue={e => this.SelectSetData("Docdate", e)}
                                            defaultdate={this.state.Docdate}
                                            open={this.state.checkenableInput['DOCDATE']}
                                        />
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> กลุ่มข้อมูล  </span>
                                                <input id="4" type="hidden" ref={this.Groupdata_code} />
                                                <input id="5" type="text" className="form-control " name="Groupdata" ref={this.Groupdata} />
                                                <span id="Docgroup" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Groupdata")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> เลขที่เอกสาร  </span>
                                                <input id="6" type="text" className="form-control " name="DeliNumber" ref={this.DeliNumber} readOnly={this.state.OpenTAXNO} />
                                                <span id="iconTaxNumber" className="input-group-addon icon">
                                                    <i className="fas fa-sync-alt" onClick={() => this.Chackdoc()}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12" >
                                            <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                                <span className="input-group-addon">พนักงาน</span>
                                                <input type="text" className="form-control hidden" ref={this.SALECODE_CODE} />
                                                <input type="text" className="form-control" ref={this.SALECODE} readOnly />
                                                <span id=" " className="input-group-addon icon">
                                                    <i className="fas fa-sync-alt" onClick={() => this.onAddValue("Csuser", this.state.siteCodeUser1)}></i>
                                                </span>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="form-group input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                                <span className="input-group-addon"> สกุลเงิน  </span>
                                                <input id="7" type="text" className="form-control " name="Currencycode" ref={this.Currencycode} value="บาท" disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={4} md={4} lg={4}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="form-group input-group col-xs-12 col-sm-12 col-md-12 col-lg-12 ">
                                                <span className="input-group-addon"> อัตราแลกเปลี่ยน  </span>
                                                <input id="8" type="text" className="form-control Price" name="exchangerate" ref={this.exchangerate} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                </div>

                <div className="container-fluid PSAppTable">
                    <BootstrapTable
                        //bordered={ false }
                        data={this.state.tableData}
                        cellEdit={cellEditProp}
                        options={options}
                        key={"1"}
                        trClassName='trClassName'
                        tableHeaderClass='trClassName'
                        height='400' hover
                        selectRow={selectRowProp}
                        deleteRow
                    >
                        <TableHeaderColumn row='0' dataAlign="center" width="45"> </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataAlign="center" width="45" dataField="any" dataFormat={this.indexN} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="170" > เอกสารตั้งหนี้ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='REFDOCNO' width="170" editable={false} dataAlign="left" isKey ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="170"> ใบกำกับภาษี </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='REFTAXNO' width="170" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"> วันที่ตั้งหนี้ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='REFDOCDATE' width="120" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"> ครบกำหนด </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='REFDUEDATE' width="120" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="right" width="120"> มูลค่าคงเหลือ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='DEBTAMOUNT' width="120" dataAlign="right" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="right" width="120"> รับชำระ < i id="t_sitecode" style={{ fontSize: "10px" }} > </i></TableHeaderColumn >
                        <TableHeaderColumn row='1' dataField='T_Payment' width="120" editable={true} dataAlign="right" ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120" > คงค้าง </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataAlign="right" width="120" dataField='T_Overdue' editable={false}></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120" > หมายเหตุ </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='REMARK' width="120" ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"> ประเภท </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='TRANSNAME' width="120" editable={false} ></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataField='REFDOCTYPE' width="120" editable={false} hidden >REFDOCTYPE</TableHeaderColumn>
                        <TableHeaderColumn row='0' rowSpan={2} dataField='T_Category_Code'></TableHeaderColumn>
                        <TableHeaderColumn row='0' dataAlign="center" width="120"  > ใบวางบิล </TableHeaderColumn>
                        <TableHeaderColumn row='1' dataField='T_Paybill' width="120" editable={false} ></TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <div className="PSAppfrom">
                    <Grid>
                        <Col xs={12} sm={8} md={8} lg={8}>
                            <Row className="show-grid">
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> แผนก  </span>
                                                <input type="hidden" ref={this.Department_code} />
                                                <input id="id1" type="text" className="form-control " name="Department" ref={this.Department}
                                                // tabIndex={4} onKeyDown={this.onKeyPress} 
                                                />
                                                <span id="CSDEPARTMENT" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Department")}>
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <SelectDatas
                                                    origin="PROJECT"  // โครงการ
                                                    valueSelect={e => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                                                    title="โครงการ"
                                                    defaultselect={this.state.PROJECT}// ค่าเริ่มต้นของ โครงการ
                                                />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> สาขา  </span>
                                                <input id="9" type="hidden" ref={this.Branch_code} />
                                                <input id="10" type="text" className="form-control " name="Branch" ref={this.Branch}
                                                // onKeyDown={this.onKeyPress} 
                                                />
                                                <span id="sitecode" className="input-group-addon icon" onClick={this.SetPopup.bind(null, "Branch")} >
                                                    <i > <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon "> ชำระอัตราตั้งหนี้(บาท)  </span>
                                                <input id="11" type="text" className="form-control Price" name="bathpayamount1" ref={this.bathpayamount1} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon "> ชำระอัตราปัจจุบัน(บาท)  </span>
                                                <input id="12" type="text" className="form-control Price" name="bathpayamount2" ref={this.bathpayamount2} disabled />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> กำไรจากอัตรา  </span>
                                                <input id="13" type="text" className="form-control Price" ref={this.bathprofit} name="bathprofit" />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> ขาดทุนจากอัตรา  </span>
                                                <input id="14" type="text" className="form-control Price" ref={this.bathloss} name="bathloss" />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> หมายเหตุ  </span>
                                                <input id="15" type="text" className="form-control " name="Remark" ref={this.Remark} />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">

                                    </Row>
                                </Col>
                                <Col xs={12} sm={6} md={6} lg={6}>
                                    <Row className="show-grid">
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12} sm={4} md={4} lg={4}>
                            <Row className="show-grid">
                                <Col xs={12} sm={12} md={12} lg={12}>
                                    <Row className="show-grid">
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon "> รวมจ่ายชำระ  </span>
                                                <input id="16" type="text" className="form-control Price" name="Sumpayamount" ref={this.Sumpayamount} disabled />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> ส่วนลด  </span>
                                                <input id="17" type="text" className="form-control Price" ref={this.Discamount} name="Discamount"
                                                    onClick={(e) => { if (e.target.value !== "") { e.target.value = parseFloat(e.target.value).toFixed(0); } }}
                                                    onKeyDown={this.Cal_Price1}
                                                    onBlur={this._calprice.bind(null)} />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12'>
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> หักเงินมัดจำ  </span>
                                                <input id="18" type="text" className="form-control Price" ref={this.Depositpayment} name="Depositpayment" value={this.state.Totalamount} disabled />
                                            </div>
                                        </div>
                                        <div className='form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12' >
                                            <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <span className="input-group-addon"> ยอดเงินสุทธิ  </span>
                                                <input id="19" type="text" className="form-control Price" ref={this.Netpayamount} name="Netpayamount" value={this.state.Debtamount} disabled />
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Grid>
                    <Snackbar place="br"
                        color={this.state.color}
                        icon={this.state.icon}
                        autoClose={this.state.autoClose}
                        message={this.state.messagealert}
                        open={this.state.opensnackbar}
                        closeNotification={() => { this.setState({ opensnackbar: false }) }}
                        close />
                </div>
            </div >
        );
    }
}